export default __webpack_public_path__ + "static/media/section3.c39652f6.png";